"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var combobox_option_1 = require("./combobox-option");
/**
 * Generic container to accommodate data required any combo-box option: the key, value and optionally the grouping
 * attributes.
 * @see MultilingualString
 */
var ComboboxOptionWithColor = /** @class */ (function (_super) {
    __extends(ComboboxOptionWithColor, _super);
    /**
     * Constructs the option with provided properties.
     * @param {T1} value
     * @param {T2} name
     * @param {string} color
     */
    function ComboboxOptionWithColor(value, name, color) {
        var _this = _super.call(this, value, name) || this;
        _this.value = value;
        _this.name = name;
        _this.color = color;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(value);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(name);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(color);
        return _this;
    }
    ;
    return ComboboxOptionWithColor;
}(combobox_option_1.ComboboxOption));
exports.ComboboxOptionWithColor = ComboboxOptionWithColor;
//# sourceMappingURL=combobox-option-with-color.js.map